"use client";

import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface DropdownProps {
  triggerLabel: React.ReactNode;
  children: React.ReactNode;
  contentClassName?: string;
  contentStyle?: React.CSSProperties;
}

export default function Dropdown({
  triggerLabel,
  children,
  contentClassName,
  contentStyle,
}: DropdownProps) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <span
          className={cn(
            "inline-flex items-center gap-2 rounded-md py-2 text-sm font-medium"
          )}
        >
          {triggerLabel}
        </span>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          onCloseAutoFocus={(e) => e.preventDefault()}
          align="start"
          sideOffset={2}
          className={cn(
            "min-w-[160px] flex flex-col rounded-lg bg-white py-3 px-4 shadow-lg z-50",
            contentClassName
          )}
          style={contentStyle}
        >
          {children}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
